// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC51hDJzJ-vNDoj83UeUft2jM-f4IXJY5o",
  authDomain: "real-time-chat-19b13.firebaseapp.com",
  databaseURL: "https://real-time-chat-19b13-default-rtdb.firebaseio.com",
  projectId: "real-time-chat-19b13",
  storageBucket: "real-time-chat-19b13.appspot.com",
  messagingSenderId: "577118810135",
  appId: "1:577118810135:web:dda23f226419e266bd6c52"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getDatabase()

export {app,db}